<mat-chip-list selectable multiple>
	<mat-chip #c="matChip" *ngFor="let option of options" [value]="option.value" (click)="toggleSelection(c)">
		<mat-icon *ngIf="c.selected">check</mat-icon>
		{{ option.label }}
	</mat-chip>
</mat-chip-list>
